import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Close, Warning } from '@mui/icons-material';
import { Button, IconButton, Typography, styled } from '@mui/material';
import hotToast from 'react-hot-toast';
const Root = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(0.5),
    alignItems: 'center',
    // these negative margin values cancel out react-hot-toasts default message styles that can't be overridden
    marginRight: '-10px',
    marginTop: theme.spacing(-0.5),
    marginBottom: theme.spacing(-0.5),
}));
export const toast = (type, message, options = {}) => {
    const defaultOptions = {};
    let toastMethod;
    // eslint-disable-next-line default-case
    switch (type) {
        case 'error':
            toastMethod = hotToast.error;
            break;
        case 'warning':
            defaultOptions.icon = _jsx(Warning, { color: "warning" });
            toastMethod = hotToast.error;
            break;
        case 'success':
            toastMethod = hotToast.success;
            break;
    }
    if (options.stayOpen && options.showCloseButton) {
        defaultOptions.duration = Infinity;
    }
    return toastMethod((t) => (_jsxs(Root, { children: [_jsx(Typography, { variant: "body1", children: message }), options.action && (_jsx(Button, { onClick: options.action.handleClick, sx: { color: 'text.primary', ml: 1 }, variant: "text", size: "small", disableRipple: true, children: options.action.label })), options.showCloseButton && (_jsx(IconButton, { onClick: () => hotToast.dismiss(t.id), size: "small", edge: "end", sx: {
                    color: 'text.primary',
                    marginY: -5,
                    // using negative margins here so the hover state is symmetrical
                    ml: options.action ? -1 : 1,
                    mr: -1,
                }, children: _jsx(Close, {}) }))] })), {
        ...defaultOptions,
        ...options,
    });
};
export const loadingToast = (promise, messages, options) => hotToast.promise(promise, messages, options);
